import BaseController from "confinus_ui/base_controller";
import { markAsSafeHTML, safelySetInnerHTML } from "lib/util/safe_html";
import http from "lib/http";

export default class ShoppingCartDropdownController extends BaseController {
  public static readonly targets = ["total"];

  declare private readonly totalTarget: HTMLElement;

  public async updateTotalOnDisplay(event: CustomEvent) {
    // basePath is the add-to-cart POST url, e.g.
    //   /entity/:entity_encoded_id/product/:product_encoded_id/cart_items
    // The cart-total fragment lives at /entity/:entity_encoded_id/carts/total,
    // so derive just the `/entity/:slug` prefix rather than slicing fixed path
    // segments (the old slice(3, 7) swallowed `product/:slug` too and 404'd).
    const entityPath = new URL(event.detail.basePath).pathname.match(
      /\/entity\/[^/]+/,
    )?.[0];
    if (!entityPath) {
      console.error(
        "Could not derive entity path from cart-total basePath",
        event.detail.basePath,
      );
      return;
    }

    // Trigger update of total price
    http
      .get<string>(`${entityPath}/carts/total`, {
        headers: { Accept: "text/fragment" },
      })
      .then((resp) => {
        safelySetInnerHTML(this.totalTarget, markAsSafeHTML(resp.data));
      })
      .catch((e) => {
        console.error("Could not fetch cart total fragment", e);
      });
  }
}
